define('plugin/news/controller/NewsController',['require','lib/controller/BaseController','plugin/news/collection/NewsCollection','plugin/news/model/NewsModel','plugin/news/view/NewsIndexView','plugin/news/view/NewsDetailsView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var NewsCollection = require('plugin/news/collection/NewsCollection');
    var NewsModel = require('plugin/news/model/NewsModel');
    var NewsIndexView = require('plugin/news/view/NewsIndexView');
    var NewsDetailsView = require('plugin/news/view/NewsDetailsView');

    /**
     * News Controller
     *
     * @class NewsController
     */
    return BaseController.extend({

        _collection: null,

        initialize: function () {
            this._collection = new NewsCollection();

            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of news
         */
        index: function() {
            this._collection.load();

            var indexView = new NewsIndexView({
                collection: this._collection
            });
            this.getMainLayout().getContentRegion().show(indexView);
        },

        view: function (id) {
            var model = new NewsModel({
                id: id
            });
            model.fetch();

            this._collection.load();

            var detailsView = new NewsDetailsView({
                model: model,
                collection: this._collection
            });
            this.getMainLayout().getContentRegion().show(detailsView);
        }

    });

});
